
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { panelTitle, PanelHeader } from "./PanelHeader.js";
import { ofArray, empty } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SupportHelpContent } from "../Widgets/SupportHelp.js";

export function HelpPanel(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "h-full", "min-h-0"])], (elems_1 = [createElement(PanelHeader, {
        Actions: empty(),
        OnClose: props.OnClose,
        TestId: "activity-panel-help",
        Title: panelTitle(patternInput[0]("general.support_and_help")),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "min-h-0", "overflow-y-auto"])], (elems = [createElement(SupportHelpContent, {
        CurrentUser: props.CurrentUser,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

